import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a88e91c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ltv-per-asin-controller"
};
const _hoisted_2 = {
  class: "metric"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "period"
}, "12 months to date")], -1));
const _hoisted_4 = {
  class: "metric-options"
};
const _hoisted_5 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metricOptions, option => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["metric", {
        selectedMetric: _ctx.currentMetricValue == option.value,
        revenue: option.value == 'revenue',
        margin: option.value == 'margin'
      }]),
      onClick: $event => $options.selectMetric(option.value)
    }, _toDisplayString(option.text), 11, _hoisted_5);
  }), 256))])])]);
}